import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { 
	Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Form,
	Input,
	Select,
	Radio,
	DatePicker,
	TimePicker,
	InputNumber
} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import internalCourseService from "../../services/Training/internal-course-service";
import {
	changeInternalCourse,
	selectInternalCourse,
	updateInternalCourse,
} from "../../actions/training-actions";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require ('../../config.json');

class InternalCourse extends ReduxComponent {

	initReload = true;
	moduleName = "training";
	childModuleName = "internalCourse";

	state = {
		currentModalStatus: false,
		importModalStatus: false,
		currentIndex: false,
		currentData: {},
		detailData: {},
		detailStatus: "unload",
		courseTypes:[],
		templateOptions: [],
		templateOptionalOptions: []
	}

	actions = {
		changeAction: this.props.changeInternalCourse,
		selectAction: this.props.selectInternalCourse,
		updateAction: this.props.updateInternalCourse,

		deleteAction: internalCourseService.deleteInternalCourse,
		createAction: internalCourseService.createInternalCourse,
		exportAction: internalCourseService.exportInternalCourse,
	}

	customComponentWillMount () {
		internalCourseService.selectCourseType({}, res => this.setState({
			courseTypes: res.data.Object
		}))
	}

	openDetailModal = modelId => this.setState({
		detailModalStatus: true,
		detailStatus: "unload",
	}, () => internalCourseService.selectInternalCourseDetail({modelId: modelId}, res => {
		if (200 === res.status) {
			this.setState({
				detailData: res.data,
				detailStatus: "loaded",
			});
		}else{
			this.setState({detailStatus: "error"})
		}
	}, err => this.setState({detailStatus: "error"})))

	closeDetailModal = () => this.setState({detailModalStatus: false})

	openCurrentModal = (modelId, index) => this.setState({
		currentModalStatus: true,
		currentStatus: "unload",
		uploadedFiles: [],
		currentFileType: 0,
		currentIndex: index,
	}, () => internalCourseService.selectInternalCourseDetail({modelId: modelId}, res => {
		if (200 === res.status) {
			let selectedMustEmployees = {};
			res.data.must_employees.forEach(employee => {
				selectedMustEmployees[employee.real_name] = employee.id;
			});
			let selectedOptionalEmployees = {};
			res.data.optional_employees.forEach(employee => {
				selectedOptionalEmployees[employee.real_name] = employee.id;
			})
			this.setState({
				currentData: res.data,
				currentStatus: "loaded",
				selectedMustEmployees: selectedMustEmployees,
				selectedOptionalEmployees: selectedOptionalEmployees,
			});
		}else{
			this.setState({currentStatus: "error"})
		}
	}, err => this.setState({currentStatus: "error"})))

	newCurrentData = () => this.setState({
		currentModalStatus: true,
		currentStatus: "loaded",
		uploadedFiles: [],
		currentFileType: 0,
		currentIndex: null,
		selectedMustEmployees: {},
		selectedOptionalEmployees: {},
		currentData: {
			actual_training_count: null,
			attachments: [],
			must_employee_ids: [],
			must_employees: [],
			optional_employee_ids: [],
			optional_employees: [],
			planned_training_count: null,
			training_end_date: null,
			training_name: null,
			training_start_date: null,
			training_teacher_id: null,
			training_type: 0,
			training_type_name: null,
			training_it_teacher_name: "",
			training_courses_type_name: ""
		}
	})

	setEmployeeFilter = value => this.actions.changeAction({
		// real_name: value,
		// job_number: value
		training_teacher_name: value
	}, "reload")

	setTypeFilter = value => this.actions.changeAction({
		training_courses_type_name: value
	}, "reload")

	closeCurrentModal = () => this.setState({currentModalStatus: false})

	selectEmployee = value => this.props.fetchEmployeesList({real_name: value})

	setCourseFileType = event => this.setState({currentFileType: event.target.value})

	setPageFilter = pagination => this.actions.changeAction({
		page: pagination.current
	}, "reload")

	deleteAttachment = index => this.setState({
		currentData: {
			...this.state.currentData,
			attachments: [
				...this.state.currentData.attachments.slice(0, index),
				...this.state.currentData.attachments.slice(index + 1)
			]
		}
	})

	setTextFile = event => this.setState({textFile: event.target.value})

	submitTextFile = () => {
		if (this.state.textFile) {
			this.setState({
				currentData: {
					...this.state.currentData,
					attachments: [
						...this.state.currentData.attachments,
						{"attachment_type": 0, attachment_content: this.state.textFile}
					]
				},
				textFile: null
			})
		}else{
			message.error("请输入文档名称！")
		}
	}

	setUploadedFile = event => this.setState({uploadedFiles: [ ...event.target.files ]})

	uploadFile = () => {
		if (this.state.uploadedFiles.length > 0) {
			let currentFile = this.state.uploadedFiles[0];
			let formData = new FormData();
			formData.append("uploadedFile", currentFile);
			internalCourseService.uploadCourseAttachments(formData, res => {
				if (res.data.Success) {
					this.setState({
						currentData: {
							...this.state.currentData,
							attachments: [
								...this.state.currentData.attachments,
								{"attachment_type": 1, attachment_content: currentFile.name}
							]
						}
					})
				}else{
					message.error("上传文件 " + currentFile.name + " 失败");
				}
				this.setState({
					uploadedFiles: this.state.uploadedFiles.slice(1)
				}, () => {
					if (this.state.uploadedFiles.length > 0) {
						this.uploadFile();
					}else{
						message.success("上传完成")
					}
				})
			}, err => {
				message.error("上传文件 " + currentFile.name + " 失败");
				this.setState({
					uploadedFiles: this.state.uploadedFiles.slice(1)
				}, () => {
					if (this.state.uploadedFiles.length > 0) {
						this.uploadFile();
					}else{
						message.success("上传完成")
					}
				})
			})			
		}else{
			message.error("请选择上传文件");
		}
	}

	publicCreate = posts => {
		if ("function" === typeof this.actions.createAction) {
			this.actions.createAction(posts, res => {
				
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("添加数据成功", 4);

					if ("function" === typeof this.actions.changeAction) {
						this.actions.changeAction();
					}else{
						this.handleError('undefined change action');
					}
				}else{
					message.error("添加数据失败 " + res.data.Errors[0], 4);
				}
				this.setState({okButtonDisable: false});
			});
		}else{
			this.handleError("undefined create action");
		}
	}

	publicUpdate = puts => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, this.state.currentIndex, res => {
								
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("修改数据成功", 4);
					this.actions.changeAction();
				}else{
					message.error("修改数据失败 " + res.data.Errors[0], 4);
				}
				this.setState({okButtonDisable: false});
			});
		}else{
			this.handleError('undefined update action');
		}
	}

	submitCurrentModal = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			this.setState({okButtonDisable: true});
			let must_employee_ids = values.must_employees.map(employee => {
				if (this.state.selectedMustEmployees.hasOwnProperty(employee)) {
					return this.state.selectedMustEmployees[employee]
				}
				return employee;
			});
			let optional_employee_ids = values.optional_employees.map(employee => {
				if (this.state.selectedOptionalEmployees.hasOwnProperty(employee)) {
					return this.state.selectedOptionalEmployees[employee]
				}
				return employee;
			})

			let currentData = {
				...this.state.currentData,
				...values,
				training_start_date: values.training_start_date.format("YYYY-MM-DD") + " " + values.training_start_time.format("HH:mm"),
				training_end_date: values.training_end_date.format("YYYY-MM-DD") + " " + values.training_end_time.format("HH:mm"),
				must_employee_ids: must_employee_ids,
				optional_employee_ids: optional_employee_ids
			}

			delete currentData.training_start_time;
			delete currentData.training_end_time;

			let callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
			callee(currentData);
		}
	})

	selectMustEmployee = (value, event) => this.setState({
		selectedMustEmployees: {
			...this.state.selectedMustEmployees,
			[value]:event.props.employee_id
		}
	})

	selectOptionalEmployee = (value, event) => this.setState({
		selectedOptionalEmployees: {
			...this.state.selectedOptionalEmployees,
			[value]:event.props.employee_id
		}
	})

	exportInternalCourse = () => {
		let gets = {};
		Object.keys(this.props[this.moduleName][this.childModuleName].filters).forEach(key => {
			if (this.props[this.moduleName][this.childModuleName].filters[key]) {
				gets[key] = this.props[this.moduleName][this.childModuleName].filters[key];
			}
		})
		delete gets.page;
		this.publicExport(gets);
	}

	joinCourse = id => internalCourseService.joinInternalCourse({id: id}, res => {
		if (res.data.Success) {
			message.success("申请课程成功", 4);
		}else{
			message.error("申请课程失败," + res.data.Errors[0], 4);
		}
	}, err => message.error("申请课程失败", 4))

	selectTrainingTeacher = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			training_teacher_id: event.props.employee_id
		}
	})

	column = [{
			title: '培训名称',
			dataIndex: 'training_name',
			key: 'training_name',
			className: 'table-global-head-short'
		}, {
			title: '课程类型',
			dataIndex: 'training_courses_type_name',
			key: 'training_courses_type_name',
			className: 'table-global-head-short'
		}, {
			title: '讲师',
			dataIndex: 'training_it_teacher_name',
			key: 'training_it_teacher_name',
			className: 'table-global-head-short'
		}, {
			title: '发布时间',
			dataIndex: 'created_time',
			key: 'created_time',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '开始时间',
			dataIndex: 'training_start_date',
			key: 'training_start_date',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '结束时间',
			dataIndex: 'training_end_date',
			key: 'training_end_date',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '计划培训人数',
			dataIndex: 'planned_training_count',
			key: 'planned_training_count',
			className: 'table-global-head-6x'
		}, {
			title: '申请人数',
			dataIndex: 'actual_training_count',
			key: 'actual_training_count',
			className: 'table-global-head-small'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-18x',
			render: (text, record, index) => {
				return (
					<span>
						{this.props.access.internalCourse.detail_value && <span>
							<Button icon="edit" size="small"
								className="row-action-btn"
								onClick={this.openDetailModal.bind(this, record.id)}>详情</Button>
						</span>}
						{this.props.access.internalCourse.u_value && <span>
							<Button icon="edit" size="small"
								className="row-action-btn"
								onClick={this.openCurrentModal.bind(this, record.id, index)}>编辑</Button>
						</span>}
						{this.props.access.internalCourse.join_value && <span>
							<Button icon="edit" size="small"
								className="row-action-btn"
								onClick={this.joinCourse.bind(this, record.id)}>参加</Button>
						</span>}
						{this.props.access.internalCourse.notify_all_value && <span>
							<Button icon="edit" size="small"
								className="row-action-btn"
								onClick={this.notifyAll.bind(this, record.id)}>通知全部</Button>
						</span>}
					</span>
				);
			} 
		}
	];

	employeeColumn = [{
			title: '姓名',
			dataIndex: 'real_name',
			key: 'real_name',
			className: 'table-global-head'
		}, {
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-short'
		}, {
			title: '部门',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '联系电话',
			dataIndex: 'phone',
			key: 'phone',
			className: 'table-global-head'
		}, {
			title: '邮箱',
			dataIndex: 'email',
			key: 'email',
			className: 'table-global-head-large'
		}, {
			title: '申请时间',
			dataIndex: 'created_date',
			key: 'created_date',
			className: 'table-global-head',
			render: text => text ? moment(text).format("YYYY-MM-DD HH:mm") : null
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-tiny',
			render: (text, record, index) => this.props.access.internalCourse.notify_value && <Button size="small"
				onClick={this.notifySingle.bind(this, record.id)}>通知</Button>
		}
	];

	courseColumn = [{
			title: '培训内容',
			dataIndex: 'attachment_content',
			key: 'attachment_content',
			className: 'table-global-head'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => this.props.access.internalCourse.d_value && <Button size="small"
				onClick={this.deleteAttachment.bind(this, index)}>删除</Button>
		}
	];

	notifyType = [
		{value: "1", text: "微信模板"},
		{value: "2", text: "邮件模板"},
		{value: "3", text: "短信"}
	]

	notifyAll = id => this.setState({
		notifyType: "all"
	}, () => this.notifyTemplate(id))

	notifySingle = id => this.setState({
		notifyType: "single"
	}, () => this.notifyTemplate(id))

	notifyTemplate = id => this.setState({
		notifyModelId: id,
		notifyModalStatus: true,
		notifyModalLoadStatus: "unload",
		templateOptionalContent: "",
		templateContent: ""
	}, () => internalCourseService.getNotifyTemplate({}, res => {
		this.props.form.resetFields();
		if (res.data.Success) {
			this.setState({
				notifyModalLoadStatus: "loaded",
				notifyTemplate: res.data.Object
			})
		}else {
			this.setState({notifyModalLoadStatus: "error"})
		}
	}, err => this.setState({notifyModalLoadStatus: "error"})))

	closeNotifyModal = () => this.setState({notifyModalStatus: false})

	notifyAction = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			let post, callee
			if (this.state.notifyType === "single") {
				post = {
					training_id: this.state.detailData.id,
					template_id: values.template_type_id,
					employee_id: this.state.notifyModelId
				}
				callee = internalCourseService.notifySingle
			}else{
				post = {
					training_id: this.state.notifyModelId,
					template_id: values.template_type_id
				}
				callee = internalCourseService.notifyAll
			}
			callee(post, res => {
				if (res.data.Success) {
					message.success("发送课程通知成功", 4);
					this.closeNotifyModal();
				}else{
					message.error("发送课程通知失败!" + res.data.Errors[0], 4);
				}
			}, err => message.error("发送课程通知失败!", 4))
		}
	})

	setTemplateData = value => this.setState({
		templateOptions: this.state.notifyTemplate[value],
		templateContent: ""
	}, () => {
		this.props.form.setFieldsValue({
			template_type_id: ""
		})
	})

	setTemplateName = (value, event) => this.setState({
		templateContent: event.props.content
	})

	render() {
		return (
			<div className="app-module-item">
				{this.state.notifyModalStatus && <Modal width="800px"
					visible={this.state.notifyModalStatus}
					title="培训通知"
					zIndex={1001}
					destroyOnClose={true}
					onCancel={this.closeNotifyModal}
					footer={[
						<Button key={1} onClick={this.closeNotifyModal}>关闭</Button>,
						<Button key={2} type="primary" onClick={this.notifyAction}>确定</Button>,
					]}>
					<div style={{textAlign:"center",margin:"0px 0px 5px",height:"320px",overflowY:"auto"}}>
					{(() => {
						switch (this.state.notifyModalLoadStatus) {
							case "loaded":
								return (
									<div className="">
										<Form layout="inline">
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="模板类型">
													{this.props.form.getFieldDecorator('template_type', {
														rules: [{ required: true, message: '请选择模板类型' }],
														initialValue: ""
													})(
														<Select onChange={this.setTemplateData} style={{width:"240px"}}>
														{this.notifyType.map(kind => (
															<Select.Option key={kind.value}
																value={kind.value}>
																{kind.text}
															</Select.Option>
														))}
														</Select>
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="模板名称">
													{this.props.form.getFieldDecorator('template_type_id', {
														rules: [{ required: true, message: '请选择模板名称' }],
														initialValue: ""
													})(
														<Select onChange={this.setTemplateName} style={{width:"240px"}}>
														{this.state.templateOptions.map(kind => (
															<Select.Option key={kind.id}
																content={kind.content}
																value={kind.id}>
																{kind.name}
															</Select.Option>
														))}
														</Select>
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Input.TextArea disabled={true} rows={6} style={{width: "700px"}} value={this.state.templateContent} />
											</div>
										</Form>
									</div>);
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>}
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="培训"
					onCancel={this.closeCurrentModal}
					destroyOnClose={true}
					footer={[
						<Button key={"API太慢了!！"} onClick={this.closeCurrentModal}>关闭</Button>,
						<Button disabled={this.state.okButtonDisable} key={"API太慢了!"} type="primary" onClick={this.submitCurrentModal}>确定</Button>,
					]}>
					<div style={{textAlign:"center",margin:"0px 0px 5px",height:"500px",overflowY:"auto"}}>
					{(() => {
						switch (this.state.currentStatus) {
							case "loaded":
								return (
									<div className="">
										<Form onSubmit={this.submitCurrentModal} layout="inline">
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="培训名称">
													{this.props.form.getFieldDecorator('training_name', {
														rules: [{ required: true, message: '请输入培训名称' }],
														initialValue: this.state.currentData.training_name
													})(<Input style={{width:"300px"}} />)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="课程类型">
													{this.props.form.getFieldDecorator('training_courses_type_name', {
														rules: [{ required: true, message: '请输入课程类型' }],
														initialValue: this.state.currentData.training_courses_type_name
													})(
													<Input style={{width:"300px"}} />
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="培训老师">
													{this.props.form.getFieldDecorator('training_it_teacher_name', {
														rules: [{ required: true, message: '请输入培训老师' }],
														initialValue: this.state.currentData.training_it_teacher_name
													})(
														<Select mode="combobox"
															style={{ width: "300px" }}
															onSearch={this.selectEmployee}
															filterOption={false}
															placeholder="请输入员工姓名"
															onSelect={this.selectTrainingTeacher} >
															{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
																this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id} 
																		value={employee.real_name}
																		employee_id={employee.id}
																		style={{width:"300px"}}>
																		{employee.real_name}
																	</Select.Option>
																)
															})}
														</Select>
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="开始时间">
													{this.props.form.getFieldDecorator('training_start_date', {
														rules: [{ required: true, message: '请输入开始日期' }],
														initialValue: this.state.currentData.training_start_date ?
															moment(this.state.currentData.training_start_date) : null
													})(<DatePicker style={{width:"180px"}} />)}
												</Form.Item><Form.Item>
													{this.props.form.getFieldDecorator('training_start_time', {
														rules: [{ required: true, message: '请输入开始时间' }],
														initialValue: this.state.currentData.training_start_date ?
															moment(this.state.currentData.training_start_date) : null
													})(<TimePicker minuteStep={30} style={{width:"120px",height:"40px",lineHeight:"40px"}} format={"HH:mm"} />)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="结束时间">
													{this.props.form.getFieldDecorator('training_end_date', {
														rules: [{ required: true, message: '请输入开始日期' }],
														initialValue: this.state.currentData.training_end_date ?
															moment(this.state.currentData.training_end_date) : null
													})(<DatePicker style={{width:"180px"}} />)}
												</Form.Item><Form.Item>
													{this.props.form.getFieldDecorator('training_end_time', {
														rules: [{ required: true, message: '请输入开始时间' }],
														initialValue: this.state.currentData.training_end_date ?
															moment(this.state.currentData.training_end_date) : null
													})(<TimePicker minuteStep={30} style={{width:"120px",height:"40px",lineHeight:"40px"}} format={"HH:mm"} />)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="参加员工">
													{this.props.form.getFieldDecorator('must_employees', {
														rules: [{ required: true, message: '请输入参加员工' }],
														initialValue: this.state.currentData.must_employees.map(employee => employee.real_name)
													})(
														<Select mode="multiple"
															style={{ width: "500px" }}
															onSearch={this.selectEmployee}
															filterOption={false}
															placeholder="请输入员工姓名"
															onSelect={this.selectMustEmployee} >
															{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
																this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id} 
																		value={employee.real_name}
																		employee_id={employee.id} >
																			{employee.real_name}
																	</Select.Option>
																)
															})}
														</Select>
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Form.Item label="开放员工">
													{this.props.form.getFieldDecorator('optional_employees', {
														rules: [],
														initialValue: this.state.currentData.optional_employees.map(employee => employee.real_name)
													})(
														<Select mode="multiple"
															style={{ width: "500px" }}
															onSearch={this.selectEmployee}
															filterOption={false}
															placeholder="请输入员工姓名"
															onSelect={this.selectOptionalEmployee} >
															{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
																this.props.employeeManagement.employeeList.Data.map(employee => {
																return (
																	<Select.Option key={employee.id} 
																		value={employee.real_name}
																		employee_id={employee.id} >
																			{employee.real_name}
																	</Select.Option>
																)
															})}
														</Select>
													)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px",marginLeft: "9px"}}>
												<Form.Item label="计划培训人数">
													{this.props.form.getFieldDecorator('planned_training_count', {
														rules: [{ required: true, message: '请输入计划培训人数' }],
														initialValue: this.state.currentData.planned_training_count
													})(<InputNumber style={{width:"300px"}} />)}
												</Form.Item>
											</div>
											<div style={{marginBottom:"15px"}}>
												<Table columns={this.courseColumn}
													bordered
													dataSource={this.state.currentData.attachments}
													style={{width: "800px", margin: "0 auto"}}
													rowKey={(record, index) => index}
													pagination={false} />
											</div>
											<div>
												<div style={{marginBottom:"15px"}}>
													<span className="modal-content-title">培训课件:</span>
													<span className="modal-content-body">
														<Radio.Group defaultValue={this.state.currentFileType}
															onChange={this.setCourseFileType}>
															<Radio.Button value={0}>文档课件</Radio.Button>
															<Radio.Button value={1}>附件课件</Radio.Button>
														</Radio.Group>
													</span>
												</div>
												<div style={{marginBottom:"15px", display: 0 === this.state.currentFileType ? "" : "none"}}>
													<div>文本地址:</div>
													<Input style={{height: "38px", width: "300px",display: "block", margin: "10px auto"}}
														value={this.state.textFile}
														onChange={this.setTextFile} />
													<Button onClick={this.submitTextFile}>添加</Button>
												</div>
												<div style={{marginBottom:"15px", display: 1 === this.state.currentFileType ? "" : "none"}}>
													<div>上传课件:</div>
													<div style={{height:"58px",marginBottom:"-58px"}}>
														<div style={{width:"300px", margin: "10px auto",height: "38px",lineHeight:"38px",border:"1px solid #d4d4d4",borderRadius:"3px"}}>
															点击选择文件，当前已选中{this.state.uploadedFiles.length}个未上传文件
														</div>
													</div>
													<Input type="file" style={{height:"38px",width: "300px", margin: "10px auto", opacity:0, cursor: "pointer"}}
														multiple
														onChange={this.setUploadedFile} />
													<Button onClick={this.uploadFile}>上传</Button>
													{ this.state.uploadedFiles.length > 0 &&
													<div>
														<div style={{width: "400px", margin:"15px 0px 15px 160px", textAlign: "left"}}>待上传文件列表:</div>
														<ul style={{listStyle: "none"}}>
															{this.state.uploadedFiles.map((file, index) => 
																<li style={{width: "400px", marginLeft:"160px", overflowY: "hidden",textAlign:"left", border: "1px solid d4d4d4"}} key={index}>{file.name}</li>)}
														</ul>
													</div>}
												</div>
											</div>
										</Form>
									</div>);
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<Modal width="1000px"
					visible={this.state.detailModalStatus}
					title="培训详情"
					destroyOnClose={true}
					onCancel={this.closeDetailModal}
					footer={[
						<Button type="primary" key="1" 
							onClick={this.notifyAll.bind(this, this.state.detailData.id)}>通知全部</Button>,
						<Button key="2" onClick={this.closeDetailModal}>关闭</Button> ]}>
					<div style={{textAlign:"center",margin:"0px 0px 5px",height:"500px",overflowY:"auto"}}>
					{(() => {
						switch (this.state.detailStatus) {
							case "loaded":
								return (
									<div>
										<div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训名称:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_name}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训老师:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_it_teacher_name}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训时间:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_start_date ? 
														moment(this.state.detailData.training_start_date).format("YYYY/MM/DD HH:mm") : null}
													&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;
													{this.state.detailData.training_end_date ?
														moment(this.state.detailData.training_end_date).format("YYYY/MM/DD HH:mm") : null}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">计划培训人数:</span>
												<span className="modal-content-body">
													{this.state.detailData.planned_training_count}
												</span>
											</div>
										</div>
										<div style={{marginTop: "30px"}}>
											<h4 style={{textAlign: "left"}}>参加培训员工列表:</h4>
											<Table columns={this.employeeColumn}
												bordered
												dataSource={this.state.detailData.must_employees}
												rowKey={record => record.id}
												pagination={false} />
										</div>
										<div style={{marginTop: "30px"}}>
											<h4 style={{textAlign: "left"}}>开放培训员工参加列表:</h4>
											<Table columns={this.employeeColumn}
												bordered
												dataSource={this.state.detailData.optional_employees}
												rowKey={record => record.id}
												pagination={false} />					
										</div>
									</div>);
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{this.props.access.internalCourse.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.newCurrentData}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.internalCourse.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					{this.props.access.internalCourse.export_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.exportInternalCourse}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Select onChange={this.setTypeFilter}
							style={{width:'116px',height:'32px',display:'inline-block',paddingLeft:'5px'}}
							value={this.props[this.moduleName][this.childModuleName].filters.training_courses_type_name}>
							<Select.Option value={""}>全部</Select.Option>
							{this.state.courseTypes.map(course => (
								<Select.Option key={course} value={course}>{course}</Select.Option>
							))}					
						</Select>
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="讲师 工号/姓名"
							onSearch={this.setEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>
					{(() => {
						switch (this.props[this.moduleName][this.childModuleName].dataStatus) {
							case "reload":
							case "loaded":
								return (
									<Table columns={this.column}
									dataSource={this.props[this.moduleName][this.childModuleName].data.Data}
									rowKey={record => record.id}
									scroll={{x: 800}}
									rowSelection={this.rowSelection}
									pagination={{
										total: this.props[this.moduleName][this.childModuleName].data.Total,
										pageSize: this.props[this.moduleName][this.childModuleName].data.PageSize,
										current: this.props[this.moduleName][this.childModuleName].filters.page}}
									onChange={this.setPageFilter} />);
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		training: state.training,
		employeeManagement: state.employeeManagement,
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	changeInternalCourse,
	selectInternalCourse,
	updateInternalCourse,
}

InternalCourse = Form.create()(InternalCourse);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(InternalCourse));







// WEBPACK FOOTER //
// ./src/routes/Training/InternalCourse.js